import { render } from "./Rating.vue?vue&type=template&id=6d6b4fe4"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"

import "./Rating.vue?vue&type=style&index=0&id=6d6b4fe4&lang=scss"
script.render = render

export default script